var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    strokeLinejoin: "round"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 8.7c-0.2-0.2-0.6-0.4-0.9-0.4 -0.3 0-0.6 0.1-0.9 0.4l-28.5 28.5c-0.2 0.2-0.4 0.6-0.4 0.9 0 0.3 0.1 0.7 0.4 0.9l10.7 10.7c0.2 0.2 0.6 0.4 0.9 0.4 0.3 0 0.7-0.1 0.9-0.4l28.5-28.5c0.2-0.2 0.4-0.6 0.4-0.9 0-0.3-0.1-0.6-0.4-0.9l-10.7-10.7Z",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 41.7c-0.2-0.2-0.3-0.3-0.5-0.3 -0.2-0.1-0.4-0.1-0.6 0 -0.2 0.1-0.4 0.2-0.6 0.3 -0.2 0.1-0.3 0.3-0.3 0.5l-5.4 16.1c-0.1 0.2-0.1 0.5 0 0.7 0.1 0.2 0.2 0.4 0.3 0.6 0.2 0.2 0.4 0.3 0.6 0.3 0.2 0.1 0.5 0 0.7 0l16.1-5.3c0.2-0.1 0.4-0.2 0.5-0.3 0.1-0.2 0.2-0.3 0.3-0.6 0.1-0.2 0-0.4 0-0.6 -0.1-0.2-0.2-0.4-0.3-0.5l-10.7-10.7Z",
    stroke: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4 2.5c-1.7-1.6-3.9-2.5-6.2-2.5 -2.3 0-4.6 0.9-6.2 2.5l-1.8 1.8c-0.2 0.2-0.4 0.6-0.4 0.9 0 0.3 0.1 0.7 0.4 0.9l10.7 10.7c0.2 0.2 0.6 0.4 0.9 0.4 0.3 0 0.7-0.1 0.9-0.4l1.8-1.8c1.6-1.7 2.6-3.9 2.6-6.2 0-2.3-0.9-4.6-2.6-6.2Z",
    stroke: "none"
  })));
};
export default SvgPencil;